module.exports = __webpack_public_path__ + "img/nav-logo.ce98fb06.png";